import React, {Component} from 'react';
import '../App.css';
import axios from 'axios';
import cookie from 'react-cookies';
import Modal from "react-bootstrap/Modal";
import Terms from './Terms';

class Signup extends Component{
    //call the constructor method
    constructor(props){
        //Call the constrictor of Super class i.e The Component
        super(props);
        //maintain the state required for this component
        this.state = {
            useremail : "",
            password : "",
            confirmPassword : "",
            first_name: "",
            last_name: "",
            status: 0,
            message: "",
            showTermsPopup: false
        }
        cookie.remove('cookieId', { path: '/' });
        //Bind the handlers to this class
        this.emailChangeHandler = this.emailChangeHandler.bind(this);
        this.passwordChangeHandler = this.passwordChangeHandler.bind(this);
        this.confirmPasswordChangeHandler = this.confirmPasswordChangeHandler.bind(this);
        this.firstNameChangeHandler = this.firstNameChangeHandler.bind(this);
        this.lastNameChangeHandler = this.lastNameChangeHandler.bind(this);
        this.submitSignup = this.submitSignup.bind(this);
    }
    
    componentWillMount(){
        // this.setState({
        //     authFlag : false
        // })
    }

    componentDidMount() {
        if (this.props.currentEmail) {
            this.setState({
                useremail: this.props.currentEmail
            })
        }
    }
    
    emailChangeHandler = (e) => {
        this.setState({
            useremail : e.target.value
        })
    }
    
    passwordChangeHandler = (e) => {
        this.setState({
            password : e.target.value
        })
    }

    confirmPasswordChangeHandler = (e) => {
        this.setState({
            confirmPassword : e.target.value
        })
    }

    firstNameChangeHandler = (e) => {
        this.setState({
            first_name : e.target.value
        })
    }

    lastNameChangeHandler = (e) => {
        this.setState({
            last_name : e.target.value
        })
    }

    showTermsPopup(e) {
        e.preventDefault();
        this.toggleTermsPopup();
    }

    toggleTermsPopup() {
        this.setState({
            showTermsPopup: !this.state.showTermsPopup
        })
    }

    handleValidation(){
        let formIsValid = true;

        if ( this.state.password !== this.state.confirmPassword ) {
            formIsValid = false;
            this.setState({
                message : this.props.dataLanguage['pwd_msg_1']
            });
        }        

        if(!this.state.confirmPassword){
            formIsValid = false;
            this.setState({
                message : this.props.dataLanguage['pwd_msg_2']
            });
        }

        if(!this.state.password){
            formIsValid = false;
            this.setState({
                message : this.props.dataLanguage['pwd_msg_3']
            });
        }

        const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([\t]*\r\n)?[\t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([\t]*\r\n)?[\t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
        if(!expression.test(String(this.state.useremail).toLowerCase())){
           formIsValid = false;
           this.setState({
                message : this.props.dataLanguage['invalid_email']
            });
        }

        if(!this.state.useremail){
            formIsValid = false;
            this.setState({
                message : this.props.dataLanguage['email_required']
            });
        }

        if(!this.state.last_name){
            formIsValid = false;
            this.setState({
                message : this.props.dataLanguage['last_name_required']
            });
        }

        if(!this.state.first_name){
            formIsValid = false;
            this.setState({
                message : this.props.dataLanguage['first_name_required']
            });
        }

        return formIsValid;
    }
    
    submitSignup = (e) => {
        e.preventDefault();
        
        if(this.handleValidation()){
            const data = {
                useremail: this.state.useremail,
                password: this.state.password,
                confirmPassword: this.state.confirmPassword,
                first_name: this.state.first_name,
                last_name: this.state.last_name
            }
            //set the with credentials to true
            axios.defaults.withCredentials = true;
            //make a post request with the user data
            axios.post(window.$backend_url + '/create',data)
                .then(response => {
                    if ( response.status === 200 ){
                        this.props.finishSignUp();
                    }
                })
                .catch(error => {
                    if ( error.response.status === 600 ) {
                        this.setState({
                            message : "The email is used already!"
                        });
                    } else {
                        this.setState({
                            message : "Adding User Unsuccessful."
                        });
                    }
                })
        }
    }

    switchPopupLogin = (e) => {
        e.preventDefault();
        this.props.switchPopupLogin();
    }   

    render(){
        return(            
            <div className="modal-signup custom-modal">
                <div className="modal-logo">
                    <img alt="logo" src="/assets/images/logo.png" />
                </div>
                <h2 className="text-center">{this.props.dataLanguage['signup']}</h2>
                <form className="signup-form">
                    { this.state.message ?
                        <p className="message-text">{ this.state.message }</p>
                    : null }
                    <div className="form-group">
                        <label>{this.props.dataLanguage['firstName']}</label>
                        <input onChange = {this.firstNameChangeHandler} type="text" className="form-control first_name" name="first_name" ></input>
                    </div>
                    <div className="form-group">
                        <label>{this.props.dataLanguage['lastName']}</label>
                        <input onChange = {this.lastNameChangeHandler} type="text" className="form-control last_name" name="last_name" ></input>
                    </div>
                    <div className="form-group">
                        <label>{this.props.dataLanguage['email']}</label>
                        <div className="user-container">
                            <input onChange = {this.emailChangeHandler} type="email" className="form-control useremail" name="useremail" value={this.state.useremail}></input>
                        </div>
                    </div>
                    <div className="form-group">
                        <label>{this.props.dataLanguage['password']}</label>
                        <div className="pwd-container ">
                            <input onChange = {this.passwordChangeHandler} type="password" className="form-control password" name="password" ></input>
                        </div>
                    </div>
                    <div className="form-group">
                        <label>{this.props.dataLanguage['confirmPwd']}</label>
                        <div className="pwd-container ">
                            <input onChange = {this.confirmPasswordChangeHandler} type="password" className="form-control password" name="confirm_password" ></input>
                        </div>
                    </div>
                    <button onClick = {this.submitSignup} type="submit" className="btn-submit">{this.props.dataLanguage['signup']}</button>
                    <p className="text-center comment-text">{this.props.dataLanguage['signup_msg']} <span className="link-yellow"><a href="" className="link-yellow" onClick={this.showTermsPopup.bind(this)}>{this.props.dataLanguage['digitX_user_agreement']}, {this.props.dataLanguage['privacy_policy']} {this.props.dataLanguage['and']} {this.props.dataLanguage['cookies_policy']}</a>.</span></p>
                </form>
                <div className="text-center">
                    <span className="other-link">{this.props.dataLanguage['have_account']} <a href="" className="link-yellow" onClick={this.switchPopupLogin}>{this.props.dataLanguage['login']}</a></span>
                </div>
                {this.state.showTermsPopup ?  
                    <Modal show={this.state.showTermsPopup} onHide={this.toggleTermsPopup.bind(this)} animation={false} className="largeModal">
                        <Modal.Header closeButton>
                        </Modal.Header>
                        <Terms dataLanguage={this.props.dataLanguage} />
                    </Modal>
                : null
                }
            </div>
        )
    }
}
//export Signup Component
export default Signup;


// WEBPACK FOOTER //
// ./src/components/Signup.js